import { createRouter, createWebHistory } from 'vue-router'
import AdminDashboard from '../components/AdminDashboard.vue'
import AdminLogin from '../components/AdminLogin.vue'
import ArtisanList from '../components/ArtisanList.vue'
import AuditLog from '../components/AuditLog.vue'
import CategoryManager from '../components/CategoryManager.vue'
import ChatViewer from '../components/ChatViewer.vue'
import ClientManager from '../components/ClientManager.vue'
import DisputeManager from '../components/DisputeManager.vue'
import FinanceManager from '../components/FinanceManager.vue'
import FraudOps from '../components/FraudOps.vue'
import WaitlistMonitor from '../components/WaitlistMonitor.vue'
import MissionsMonitor from '../components/MissionsMonitor.vue'
import OrgManager from '../components/OrgManager.vue'
import PromoManager from '../components/PromoManager.vue'
import ReportsManager from '../components/ReportsManager.vue'
import SavManager from '../components/SavManager.vue'
import SupportDispatch from '../components/SupportDispatch.vue'
import SmsCenter from '../components/SmsCenter.vue'
import PushCenter from '../components/PushCenter.vue'
import UserManager from '../components/UserManager.vue'
import AccountProfile from '../components/AccountProfile.vue'
import PlatformSettings from '../components/PlatformSettings.vue'
import { adminNavItems } from '../navigation/adminNavigation'

const componentById = {
  dispatch: SupportDispatch,
  dashboard: AdminDashboard,
  artisans: ArtisanList,
  clients: ClientManager,
  waitlist: WaitlistMonitor,
  missions: MissionsMonitor,
  finance: FinanceManager,
  users: UserManager,
  categories: CategoryManager,
  fraud: FraudOps,
  disputes: DisputeManager,
  reports: ReportsManager,
  sav: SavManager,
  chat: ChatViewer,
  audit: AuditLog,
  promos: PromoManager,
  orgs: OrgManager,
  sms: SmsCenter,
  push: PushCenter,
  settings: PlatformSettings,
}

const navRoutes = adminNavItems.map((item) => ({
  path: item.path,
  name: item.id,
  component: componentById[item.id],
  meta: {
    navId: item.id,
    label: item.label,
    pageTitle: item.label,
    permissions: item.permissions,
  },
}))

const routes = [
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    name: 'login',
    component: AdminLogin,
    meta: { navId: 'login', label: 'Connexion', pageTitle: 'Connexion', public: true },
  },
  {
    path: '/profile',
    name: 'profile',
    component: AccountProfile,
    meta: { navId: 'profile', label: 'Mon Compte', pageTitle: 'Mon Compte' },
  },
  ...navRoutes,
  {
    path: '/chat/:interventionId?',
    name: 'chat-detail',
    component: ChatViewer,
    meta: {
      navId: 'chat',
      label: 'Conversations',
      pageTitle: 'Conversation',
      permissions: ['chat.read.any'],
    },
  },
  {
    path: '/users/:id',
    name: 'users-detail',
    component: UserManager,
    meta: {
      navId: 'users',
      label: 'Comptes',
      pageTitle: 'Dossier compte',
      permissions: ['users.read.any'],
    },
  },
  {
    path: '/missions/:id',
    name: 'missions-detail',
    component: MissionsMonitor,
    meta: {
      navId: 'missions',
      label: 'Missions',
      pageTitle: 'Suivi de mission',
      permissions: ['missions.read.any'],
    },
  },
  { path: '/:pathMatch(.*)*', redirect: '/login' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
